import { InjectionToken } from '@angular/core';

export interface SalesOfferConfig {
  apiUrl: string;
}

/** Creates a document module configuration injection token */
export const SALES_OFFER_CONFIG = new InjectionToken<SalesOfferConfig>('SalesOfferConfig');
